import { api } from './client';
import { bookingAccessParams, storeBookingAccess } from '../utils/bookingAccess';
import i18n from '../i18n';

export const getBookingDetails = async (bookingId) => {
  try {
    const response = await api.get(`/bookings/${bookingId}/`, {
      params: bookingAccessParams(bookingId),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const cancelBookingById = async (bookingId, legIndex) => {
  try {
    const access = bookingAccessParams(bookingId);
    const body = { ...access };
    if (legIndex) body.leg_index = legIndex;
    const response = await api.post(`/bookings/${bookingId}/cancel/`, body, {
      params: access,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const manualCancelBookingById = async (bookingId, legIndex) => {
  try {
    const body = legIndex ? { leg_index: legIndex } : {};
    const response = await api.post(`/bookings/${bookingId}/manual_cancel/`, body);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const cancelPassengerTicket = async (bookingId, passengerId) => {
  try {
    const response = await api.post(
      `/bookings/${bookingId}/passengers/${passengerId}/cancel/`,
      bookingAccessParams(bookingId)
    );
    return response.data;
  } catch (error) {
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw error;
  }
};

export const getBookings = async (params = {}) => {
  try {
    const response = await api.get("/bookings/", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const confirmRefundBooking = async (bookingId, legIndex, passengerId) => {
  try {
    const body = {};
    if (legIndex) body.leg_index = legIndex;
    if (passengerId) body.passenger_id = passengerId;
    const response = await api.post(`/bookings/${bookingId}/confirm_refund/`, body);
    return response.data;
  } catch (error) {
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw new Error(i18n.t("apiErrors.refund"));
  }
};

export const refundBooking = async (bookingId, legIndex) => {
  try {
    const body = { ...bookingAccessParams(bookingId) };
    if (legIndex) body.leg_index = legIndex;
    const response = await api.post(`/bookings/${bookingId}/refund/`, body);
    return response.data;
  } catch (error) {
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    } else {
      throw new Error(i18n.t("apiErrors.refund"));
    }
  }
};

export const createManualBooking = (data) => {
  return api.post("/bookings/manual_create/", data).then((res) => {
    storeBookingAccess(res.data?.booking_id, res.data?.access_token);
    return res.data;
  });
};

export const createManualItineraryBooking = (data) => {
  return api.post("/bookings/manual_create_itinerary/", data).then((res) => {
    storeBookingAccess(res.data?.booking_id, res.data?.access_token);
    return res.data;
  });
};

export const createManualRoundTripBooking = (data) => {
  return api.post("/bookings/manual_create_round_trip/", data).then((res) => {
    storeBookingAccess(res.data?.booking_id, res.data?.access_token);
    return res.data;
  });
};

export const markNoShow = async (bookingId, comment = "") => {
  const response = await api.post(`/bookings/${bookingId}/mark_no_show/`, {
    comment,
  });
  return response.data;
};

export const updateBookingFundsHolder = async (bookingId, fundsHolder) => {
  const response = await api.patch(`/bookings/${bookingId}/funds_holder/`, {
    funds_holder: fundsHolder,
  });
  return response.data;
};

export const updateBookingComment = async (bookingId, comment) => {
  const response = await api.patch(`/bookings/${bookingId}/update_comment/`, {
    comment,
  });
  return response.data;
};
